import { Modal } from 'react-bootstrap';
import { Button, InputField } from '../../atoms';
import styles from './AddIndicatorModal.module.css';
import { FC } from 'react';
import { CustomDropdown } from '../../molecules';
import { GoalResponseDto } from '../../../store/landscapeAPI/goal/dto/response/goal-response.dto';
import { IndicatorResponseDto } from '../../../store/landscapeAPI/indicator/dto/response/indicator-response.dto';
import { useNavigate } from 'react-router-dom';

interface AddIndicatorModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  goals: GoalResponseDto[];
  setSelectedGoal: (id: string) => void;
  selectedGoal: string | undefined;
  indicators: IndicatorResponseDto[];
  setDescription: (value: string) => void;
  setSelectedIndicator: (id: string) => void;
  callbackFn: () => void;
}

const AddIndicatorModal: FC<AddIndicatorModalProps> = ({
  show,
  setShow,
  goals,
  setSelectedGoal,
  selectedGoal,
  indicators,
  setDescription,
  setSelectedIndicator,
  callbackFn,
}) => {
  const navigate = useNavigate();

  const goalItems = goals.map((item) => ({
    eventKey: item.id,
    label: item.name,
  }));

  const initialGoalItem = goalItems.find(
    (item) => item.eventKey === selectedGoal
  )?.label;

  const indicatorItems = indicators.map((item) => ({
    eventKey: item.id,
    label: item.name,
  }));

  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <div className={styles.modal}>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.modalInput}>
            <CustomDropdown
              initialTitle={initialGoalItem ?? 'Select a goal'}
              items={goalItems}
              onSelectOption={(e) => {
                setSelectedGoal(e.eventKey);
              }}
            />
          </div>
          <div className={styles.modalInput}>
            <CustomDropdown
              initialTitle="Select an indicator"
              items={indicatorItems}
              onSelectOption={(e) => setSelectedIndicator(e.eventKey)}
            />
          </div>
          <div className={styles.modalInput}>
            <InputField
              type="text"
              id="description"
              placeholder="Indicator description..."
              onChange={setDescription}
            />
          </div>
          <div className={styles.bodyButtons}>
            <Button onClick={() => callbackFn()} variant="dark">
              Add
            </Button>
            <Button
              className={styles.buttonBorder}
              variant="light"
              onClick={() => setShow(false)}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.footerButtons}>
          <Button
            onClick={() => navigate(`/reporting-details/goals/add`)}
            className={styles.buttonBorder}
            variant="light"
          >
            Create New Goal
          </Button>
          <Button
            className={styles.buttonBorder}
            variant="light"
            onClick={() => navigate(`/reporting-details/indicators/add`)}
          >
            Create New Indicator
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default AddIndicatorModal;
